import { render, staticRenderFns } from "./CheckoutResult.vue?vue&type=template&id=4820e0f6&"
import script from "./CheckoutResult.vue?vue&type=script&lang=js&"
export * from "./CheckoutResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports